// extracted by mini-css-extract-plugin
export default {"header":"header_header__Cv06x","title":"header_title__OsxPF","userWrap":"header_userWrap__vQHuf"};